/** Reset product list filter state (e.g. on login/logout). */
export function getClearedProductListFilters(loggedIn: boolean) {
	return {
		selectedFilters: {},
		selectedCategories: ["mobile"],
		filteredProductList: [] as FilteredListProduct[],
		showEligibleProducts: loggedIn,
	};
}
